import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

const Input = forwardRef(
  (
    {
      type,
      name,
      label,
      className,
      errors,
      errorMessage,
      requiredLabel,
      disabled = false,
      value,
      isBlurLabel = false,
      iconRight = <></>,
      autoComplete = "off",
      ...rest
    },
    ref
  ) => {
    return (
      <div className={`input-group${isBlurLabel ? "-blur" : ""}`} ref={ref}>
        <input
          type={type}
          name={name}
          id={name}
          className={twMerge(
            `input${isBlurLabel ? "-blur" : ""}`,
            errors
              ? `border-[1.5px] border-red-500${isBlurLabel ? " error-blur" : ""}`
              : "border-[1.5px] border-gray-400",
            disabled ? `bg-gray-200` : `bg-transparent`,
            disabled && ![null, "", " ", "undefined"].includes(value) && "disabled-value",
            className
          )}
          placeholder=" "
          required
          autoComplete={autoComplete}
          disabled={disabled}
          value={value}
          {...rest}
        />
        <label
          className={twMerge(
            `input-label${isBlurLabel ? "-blur" : ""}`,
            errors ? `text-red-500${isBlurLabel ? " error-blur" : ""}` : "text-gray-500"
          )}
          htmlFor={name}
        >
          {label || ""}
          {requiredLabel && <span className="text-red-500 ml-1">*</span>}
        </label>
        {iconRight}
        {errorMessage && <p className="text-red-500 pt-[0.15rem]">{errorMessage}</p>}
      </div>
    );
  }
);

export default Input;
